import { mathService, numberHelpers } from '@approvalmax/utils';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { netSuiteExpenseLinesState } from 'shared/states';

import { setCurrencyPrecision } from '../../../helpers';
import { useCurrencyPrecision } from '../../../hooks';
import { netSuiteExpenseReportFieldValuesState } from '../../NetSuiteExpenseReportRequestForm.states';

export const useExpenseReportAmount = () => {
    const fieldValues = useAtomValue(netSuiteExpenseReportFieldValuesState);
    const expenseLines = useAtomValue(netSuiteExpenseLinesState);

    const currencyPrecision = useCurrencyPrecision(fieldValues.currency);

    return useMemo(() => {
        const expenses = expenseLines.reduce((total, current) => {
            if (numberHelpers.isNumber(current.grossAmount)) {
                return mathService.add(total, current.grossAmount);
            }

            if (numberHelpers.isNumber(current.amount)) {
                return mathService.add(total, current.amount);
            }

            return total;
        }, 0);

        const totalExpenses = setCurrencyPrecision(expenses, currencyPrecision);
        const advanceToApply = setCurrencyPrecision(fieldValues.advance, currencyPrecision) ?? 0;
        const totalReimbursableAmount = setCurrencyPrecision(
            mathService.subtract(totalExpenses, advanceToApply),
            currencyPrecision
        );

        return {
            totalExpenses,
            advanceToApply,
            totalReimbursableAmount,
        };
    }, [expenseLines, currencyPrecision, fieldValues.advance]);
};
